import { render } from "./productoSeleccionadoCard.vue?vue&type=template&id=5ce9b676&scoped=true"
import script from "./productoSeleccionadoCard.vue?vue&type=script&lang=js"
export * from "./productoSeleccionadoCard.vue?vue&type=script&lang=js"

import "./productoSeleccionadoCard.vue?vue&type=style&index=0&id=5ce9b676&scoped=true&lang=css"
import "./productoSeleccionadoCard.vue?vue&type=style&index=1&id=5ce9b676&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce9b676"]])

export default __exports__